import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSoundFx: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSoundFx"><Path d="M6 7.5H1.5V16.5H6L12.5 20.25V3.75L6 7.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M19.5 5L20.5804 7.91964L23.5 9L20.5804 10.0804L19.5 13L18.4196 10.0804L15.5 9L18.4196 7.91964L19.5 5Z" fill="currentColor"/><Path d="M17.5 13L18.3103 15.1897L20.5 16L18.3103 16.8103L17.5 19L16.6897 16.8103L14.5 16L16.6897 15.1897L17.5 13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSoundFx;
